import React, { useEffect } from 'react'
import { withAppContext } from 'src/store/initAppContext';
import styled, { withTheme } from 'styled-components';
import { LazyLoadImage } from "react-lazy-load-image-component";
import config from "src/config/config";
import PlaceholderImage from 'src/components/Placeholder';
import { theme } from 'styled-tools';

function AviatorBetToWinBoost(props: any) {
    const { app: {
        brandId
    }, theme } = props;

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    return (
        <>
            <InformationWrapper>
                <TitleText>
                    {
                        (brandId == 33 || brandId == 34) ? (
                            <p>Transform your <span className='brandColor'>Asia Cup</span> betting into Free Bets on Turbo Stars. <br /> Stake more during the tournament, <span className='brandColor'>get more rewards!</span></p>
                        ) : 
                        (brandId == 39 || brandId == 40) ? (
                            <p>Convert your Asia Cup wagers into Free Bets on <span className='brandColor'>JILI Slots</span>. <br /> <span className='brandColor'>Bet big, spin bigger!</span></p>
                        ) : 
                        (<p>Turn your <span className='brandColor'>Asia Cup stakes</span> into Free <span className='brandColor'>Bets on Aviator!</span> The more you bet during <br /> the tournament, the bigger your Aviator bonus</p>
                        )
                    }
                </TitleText>

                <KeyDetailsSec>
                    <MainTitle>How to participate</MainTitle>
                    <KeyDetailsSecWrap>
                        <KeyDetailsSecBox>
                            <img src={`${config.imageV3Host}/static/cashsite/${theme.image.AviatorBetToWinBoostIconOne}`} />
                            <p>Place qualifying bets during the Asia Cup.</p>
                        </KeyDetailsSecBox>

                        <KeyDetailsSecBox>
                            <img src={`${config.imageV3Host}/static/cashsite/${theme.image.AviatorBetToWinBoostIconTwo}`} />
                            <p>Cross staking tiers to unlock Free Bets.</p>
                        </KeyDetailsSecBox>

                        <KeyDetailsSecBox>
                            <img src={`${config.imageV3Host}/static/cashsite/${theme.image.AviatorBetToWinBoostIconThree}`} />
                            <p>Receive Free Bets credited after the tournament.</p>
                        </KeyDetailsSecBox>
                    </KeyDetailsSecWrap>
                </KeyDetailsSec>

                <ImageWrapper>
                    <MainTitle>Reward Tiers</MainTitle>
                    <Container>
                        <LazyLoadImage
                            src={`${config.imageV3Host}/static/cashsite/${theme.image.AviatorBetToWinBoostTierImg}`}
                            alt="Reward Tiers"
                            effect="none"
                            placeholder={<PlaceholderImage />}
                        />
                    </Container>
                </ImageWrapper>

                <TermsAndCondition>
                    <MainTitle>Terms & Conditions</MainTitle>
                    <ol>
                        <li>Place bets worth ₹1,00,000 or more during Asia Cup (Sep 9-25).</li>
                        <li>Only bets on Exchange markets are considered.</li>
                        <li>Free Bets credited by Sep 28, 2025.</li>
                        <li>Free Bets valid only on respective providers.</li>
                        <li>Standard brand T&Cs apply.</li>
                    </ol>
                </TermsAndCondition>
            </InformationWrapper>
        </>
    )
}

export default withTheme(withAppContext(AviatorBetToWinBoost));

const InformationWrapper = styled.div`
    width: 98%;
    height: auto;
    padding: 1.5rem 0 3rem 0;
    margin: 0em 1.2em 0 1.2em;
    border: 1px solid #fff;  
    display: flex;
    flex-direction: column;
    background: url(${config.imageV3Host}/static/cashsite/${theme("image.AviatorBetToWinBoostBg")});
    background-position: top;
    background-size: cover;
    background-repeat: no-repeat;
    overflow: hidden;

    .brandColor {
        color: ${theme('palette.AviatorBTWBBoldTextColor')};
        font-weight: 700;
    }
`;

const TitleText = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 1rem;
    position: relative;
    gap: 15px;

    p {
        color: ${theme('palette.AviatorBTWBTextColor')};
        text-align: center;
        font-size: 15px;
        font-style: normal;
        font-weight: 400;
        line-height: 28px;
        text-transform: capitalize;
        margin: 0;
    }
`;

const ImageWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-bottom: 2rem;
    position: relative;
    padding-top: 2rem;
`;

const Container = styled.div`
    width: 100%;
    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    & img {
        width: ${theme('palette.AviatorBTWBTierImgWidth')};
        height: auto;
    }
`;

const MainTitle = styled.h2`
    width: 100%;
    color: ${theme('palette.AviatorBTWBMh2Color')};
    text-align: center;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-transform: capitalize;
    margin: 0;
    padding: 1rem 1rem 2rem 1rem;
`;

const KeyDetailsSec = styled.div`
    display: flex;
    flex-direction: column;
    margin: 1rem auto;
    width: 70%;
    height: auto;
`;

const KeyDetailsSecWrap = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: stretch;
    gap: 1.5rem;
`;

const KeyDetailsSecBox = styled.div`
    width: 27%;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 10px;
    padding: 1.5rem 3rem;
    border-radius: 14px;
    border: ${theme('palette.AviatorBTWBMKeyWrapperBorder')};
    background: ${theme('palette.AviatorBTWBMKeyWrapperBg')};
    backdrop-filter: ${theme('palette.AviatorBTWBMKeyWrapperBf')};
    box-shadow: ${theme('palette.AviatorBTWBMKeyWrapperBS')};

    img {
        width: 65px;
    }

    & p {
        color: ${theme('palette.AviatorBTWBMCardTextColor')};
        text-align: center;
        font-size: 15px;
        font-style: normal;
        font-weight: 700;
        line-height: 20px;
        text-transform: capitalize;
        margin: 3px 0px;
        width: 80%;
    }
`;

const TermsAndCondition = styled.div`
    width: 45%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 1rem auto;
    padding: 1rem;
    
    ol {
        list-style: none;
        padding: 0;
        margin: 0;
        display: flex;
        list-style-type: disc;
        justify-content: center;
        flex-direction: column;
        align-items: flex-start;
        gap: 5px;

        li {
            color: ${theme('palette.AviatorBTWBTextColor')};
            text-align: justify;
            font-size: 15px;
            font-style: normal;
            font-weight: 400;
            line-height: 28px;
            text-transform: capitalize;
        }
    }
`;
